import * as React from "react";

function BarIcon(props) {
	return (
		<svg viewBox="0 0 24 24" fill="none" height="1em" width="1em" {...props}>
			<path
				d="M4.5 10.5h15"
				stroke="currentColor"
				strokeWidth="1.9"
				strokeLinecap="round"
			/>
			<rect
				x="6.2"
				y="6.2"
				width="11.6"
				height="4.4"
				rx="1.6"
				stroke="currentColor"
				strokeWidth="1.8"
			/>
			<path
				d="M7.5 10.8V17.5M16.5 10.8V17.5M5.8 17.8h3.4M14.8 17.8h3.4"
				stroke="currentColor"
				strokeWidth="1.8"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

export default BarIcon;
